export const stageArray = ['creation', 'cutting', 'sampling_digitizer', 'secendory_process', 'embroidary', 'production', 'packing', 'account', 'payment', 'dispatch'];
export const stageArray2 = ['creation', 'cutting', 'sampling_digitizer', 'secendory_process', 'embroidary', 'production', 'packing', 'account', 'payment', 'dispatch', "completed"];
export const DIGITIZER_STAGE_VALUE = 'digitizer';

export function removeNaNFromArray(arr) {
  return arr.filter(value => !Number.isNaN(value));
}

export function arrayToQueryParam(paramName, values) {
  if (values.length === 0) {
    return '';
  }

  if (paramName === 'jobid') {
    // For jobid, join values with commas in a single parameter
    return `&${paramName}=${values.join(',')}`;
  } else {
    // For other parameters, create multiple query parameters
    const queryParam = values.map(value => `${paramName}=${value}`).join('&');
    return `&${queryParam}`;
  }
}

export function queryParamToArray(queryParam) {
  if (!queryParam) {
    return [];
  }

  const paramsArray = queryParam.split('&');
  const values = paramsArray.map(param => {
    const value = param.split('=')[1];
    return parseInt(value);
  });

  return removeNaNFromArray(values);
}

// Function to parse jobid query params as strings (supports alphanumeric serial numbers like "123A")
export function queryParamToArrayForJobid(queryParam) {
  if (!queryParam) {
    return [];
  }

  // Extract jobid parameter value (format: &jobid=123,124A,125B)
  const jobidMatch = queryParam.match(/jobid=([^&]*)/);
  if (!jobidMatch) {
    return [];
  }

  const jobidValue = jobidMatch[1];
  if (!jobidValue) {
    return [];
  }

  // Split by comma and trim each value (keep as strings to support alphanumeric)
  return jobidValue.split(',').map(id => id.trim()).filter(Boolean);
}

export function queryParamToArray2(queryParam) {
  if (!queryParam) {
    return [];
  }

  const paramsArray = queryParam.split('&').filter(Boolean);
  const values = [];

  paramsArray.forEach((param) => {
    const [key, rawValue] = param.split('=');
    if (key === 'current_stage' && rawValue) {
      values.push(rawValue);
    }
    if (key === 'is_degitizer_stage' && String(rawValue).toLowerCase() === 'true') {
      values.push(DIGITIZER_STAGE_VALUE);
    }
  });

  return values;
}